import { render, staticRenderFns } from "./editChild.vue?vue&type=template&id=00b238f3&scoped=true&"
import script from "./editChild.vue?vue&type=script&lang=js&"
export * from "./editChild.vue?vue&type=script&lang=js&"
import style0 from "./editChild.vue?vue&type=style&index=0&id=00b238f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b238f3",
  null
  
)

export default component.exports